'use client';

import dynamic from 'next/dynamic';
import { ReactPlayerProps } from 'react-player';

const ReactPlayer = dynamic(() => import('react-player/youtube'), {
  ssr: false,
});

type Props = ReactPlayerProps & {
  url: string;
};

export default function Player({
  url,
  playing,
  controls,
  onEnded,
  onStart,
  light,
  muted,
}: Props) {
  return (
    <div style={{ paddingTop: '56.25%', position: 'relative' }}>
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
        }}
      >
        <ReactPlayer
          url={url}
          controls={controls}
          light={light}
          playing={playing}
          onEnded={onEnded}
          onStart={onStart}
          muted={muted}
          width="100%"
          height="100%"
        />
      </div>
    </div>
  );
}
